module.exports = __webpack_public_path__ + "img/return-box.81131d8f.svg";